import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {roleIcons} from '../iconMap';
import Brand from './Brand';
import LanguageToggle from './LanguageToggle';

function Landing({language, setLanguage, selectedRole, setSelectedRole, onContinue, onSignIn, onInvitation, t}) {
  return <main className="landing">
    <div className="landing-accent" />
    <header className="landing-header"><Brand /><LanguageToggle language={language} onChange={setLanguage} label={t.language} english={t.english} spanish={t.spanish} /></header>
    <motion.section className="entry-card auth-entry-card" initial={{opacity: 0, y: 18}} animate={{opacity: 1, y: 0}}>
      <div className="entry-intro"><span className="eyebrow">GFI INTERNATIONAL</span><h1>{t.appName}</h1><p>{t.tagline}</p></div>
      <div className="entry-actions">
        <button type="button" className="primary-button" onClick={onSignIn}><SafeIcon icon={FiIcons.FiLogIn} />{t.signIn}</button>
        <button type="button" className="invitation-entry-button" onClick={onInvitation}><SafeIcon icon={FiIcons.FiMail} />{t.invitationLink}<SafeIcon icon={FiIcons.FiArrowRight} /></button>
      </div>
      <div className="demo-mode">
        <div className="demo-mode-heading"><span>{t.demoDivider}</span></div>
        <div className="role-heading"><span className="eyebrow">{t.demoMode}</span><h2>{t.chooseRole}</h2><p>{t.demoModeHelper}</p></div>
        <div className="role-grid">{['agent', 'recruiter', 'trainer', 'admin'].map((role) => <button type="button" className={`role-card ${selectedRole === role ? 'selected' : ''}`} onClick={() => setSelectedRole(role)} aria-pressed={selectedRole === role} key={role}><span className="role-icon"><SafeIcon icon={roleIcons[role]} /></span><span><strong>{t[role]}</strong><small>{t[`${role}Description`]}</small></span><span className="role-radio" aria-hidden="true" /></button>)}</div>
        <button type="button" className="demo-continue-button" onClick={onContinue}>{t.continueDemo}</button>
      </div>
    </motion.section>
  </main>;
}

export default Landing;